import { render, staticRenderFns } from "./SlideTabs.vue?vue&type=template&id=5b485bc4&scoped=true&"
import script from "./SlideTabs.vue?vue&type=script&lang=js&"
export * from "./SlideTabs.vue?vue&type=script&lang=js&"
import style0 from "./SlideTabs.vue?vue&type=style&index=0&id=5b485bc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b485bc4",
  null
  
)

export default component.exports